/**
 * Update interval constants
 */
import { TEN_SECONDS } from './duration.mjs'

export const UPDATE_INTERVAL_DURATION = TEN_SECONDS
